document.addEventListener('DOMContentLoaded', () => {
  const header = document.getElementById('site-header')
  if (!header) return

  const onScroll = () => {
    header.classList.toggle('scrolled', window.scrollY > 30)
  }

  window.addEventListener('scroll', onScroll, { passive: true })

  // Smooth scroll with easing and header offset
  function scrollTo(target: HTMLElement, duration = 800) {
    const offset  = header.offsetHeight + 16
    const start   = window.scrollY
    const end     = target.getBoundingClientRect().top + start - offset
    const diff    = end - start
    let startTime: number | null = null

    function easeInOutCubic(t: number) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2
    }

    function step(now: number) {
      if (!startTime) startTime = now
      const elapsed  = now - startTime
      const progress = Math.min(elapsed / duration, 1)
      window.scrollTo(0, start + diff * easeInOutCubic(progress))
      if (progress < 1) requestAnimationFrame(step)
    }

    requestAnimationFrame(step)
  }

  document.querySelectorAll<HTMLAnchorElement>('a[href*="#"]').forEach((link) => {
    link.addEventListener('click', (e) => {
      const hash = (link.getAttribute('href') ?? '').split('#')[1]
      if (!hash) return
      const target = document.getElementById(hash)
      if (!target) return
      e.preventDefault()
      scrollTo(target)
    })
  })

  // Active nav link via IntersectionObserver
  const sections = document.querySelectorAll<HTMLElement>('section[id]')
  const navLinks = document.querySelectorAll<HTMLAnchorElement>('.site-nav a[href*="#"]')

  if (!sections.length || !navLinks.length) return

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          for (const link of navLinks) {
            link.classList.toggle(
              'active',
              link.getAttribute('href')?.includes(`#${entry.target.id}`) ?? false,
            )
          }
        }
      }
    },
    { rootMargin: '-30% 0px -60% 0px' },
  )

  for (const section of sections) {
    observer.observe(section)
  }
})
